import { AnimatePresence, motion } from "framer-motion";

interface DiscountCodeModalProps {
  onClose: () => void;
}

const DiscountCodeModal = ({ onClose }: DiscountCodeModalProps) => {
  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={() => onClose()}
      >
        <motion.div
          className="w-[340px] md:w-xl min-h-[345px] rounded-2xl shadow-lg p-6 flex flex-col justify-center
                         bg-[linear-gradient(to_right,_#87833F,_#E4D95C)] text-white"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ type: "spring", duration: 0.4 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="absolute inset-0 flex items-center justify-center pointer-events-none"
            style={{ zIndex: 0 }}
          >
            <div className="w-[180px] sm:w-[200px] h-[180px] sm:h-[200px] bg-black rounded-full text-center flex items-center justify-center flex-col">
              <p className="font-kalameh text-lg">کد تخفیف شما</p>
              <p className="font-kalameh text-lg">123456</p>
            </div>
          </div>

          {/* محتوای اصلی */}
          <div className="relative flex items-center justify-center flex-col gap-5 text-center z-10">
            <img
              src="/images/musical.png"
              alt="gift"
              width={314}
              height={200}
            />
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default DiscountCodeModal;
